import { Button, Drawer, Input, message, Popover, Select, Space, Table, Tag, Upload } from "antd";
import Column from "antd/es/table/Column";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {baseUrl} from "../../../../src/config"
import {
    EditOutlined,
    DeleteOutlined,
    UploadOutlined
  } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
interface DataType {
  key: React.Key;
  firstName: string;
  lastName: string;
  age: number;
  address: string;
  tags: string[];
}

const initialReq={
    id:null,
    name:null,
    description:"",
    images:[],
    categoryId:null,
}
export const ProductsPage = () => {
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editingTagIndex, setEditingTagIndex] = useState(null);
    const [categories, setCategories] = useState([]);
    const storedData = localStorage.getItem("loginData");
    const loginData = JSON.parse(storedData);
    const [productsReq,setProductsReq]=useState(initialReq)
    const navigate = useNavigate();
const [products,setProducts]=useState([])
const [serviceReq,setServiceReq]=useState({
    title:"",
    description:"",
    profile:""
})
const [drawerVisibility,setDrawerVisibility]=useState("")
const [loading, setLoading] = useState(false); // Loading state for update


// Close the drawer
const onClose = () => {
  setDrawerVisibility("");
  setProductsReq({
    id:null,
    name:null,
    description:"",
    images:null,
    categoryId:null,
  })
};
   const getProducts = async (firstResult = "0", maxResult = "-1") => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('firstResult', firstResult);
    queryParams.append('maxResult', maxResult);

    const resp = await axios.get(
      `${baseUrl}account/${loginData.id}/products?${queryParams.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${loginData.authToken}`,
        },
      }
    );

    console.log(resp.data); // Log the response to check
    setProducts(resp?.data);
  } catch (e) {
    if (e.response?.status === 401) {
      navigate("/admin/login");
    }
    console.error(e);
  }
};


      const updateProduct = async () => {
        try {
          const resp = await axios.put(
            `${baseUrl}account/${loginData.id}/product/update`,productsReq,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            message.success("Product updated successfully")
            setDrawerVisibility("")
            getProducts()
          }
        
        } catch (e) {
          console.error(e);
           if(e.response.status===401){
                          navigate("/admin/login")
                      }
          message.error("Failed to update service")
        }
      }
      const addProducts = async () => {
        try {
          const resp = await axios.post(
            `${baseUrl}account/${loginData.id}/product/add`,productsReq,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            
            message.success("Product added successfully")
            setDrawerVisibility("")
            getProducts()
          }
        
        } catch (e) {
          console.error(e);
           if(e.response.status===401){
                          navigate("/admin/login")
                      }
          message.error("Failed to add products")
        }
      }
      const deleteProducts = async (id) => {
        try {
          const resp = await axios.delete(
            `${baseUrl}account/${loginData.id}/products/${id}`,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            message.success("Product deleted successfully")
            getProducts()
          }
        
        } catch (e) {
          console.error(e);
          message.error("Failed to delete product")
          if(e.response.status==401){
            navigate("/admin/login")
        }
        }
      }
    const handlePreview = (file) => {
        const reader = new FileReader();
        reader.onload = () => {
          const image: any = new Image();
          image.src = reader.result;
          document.body.append(image);
        };
        reader.readAsDataURL(file.originFileObj); // Read the file as data URL
      };
      const handleFileChange = ({ fileList }) => {
        console.log("File uploaded: ", fileList);
        if (fileList && fileList.length > 0) {
          const file = fileList[0].originFileObj;
          const reader = new FileReader();
          reader.onloadend = () => {
            setProductsReq({
              ...productsReq,
              images: [...productsReq?.images,reader.result as string], // Set the profile picture as Base64 string
            });
          };
          reader.readAsDataURL(file); // Convert the image to Base64
        }
      };
    useEffect(() => {
        const storedData = localStorage.getItem("loginData");
        if (storedData) {
            const loginData = JSON.parse(storedData);
            const userId = loginData.id;
            console.log("User ID:", userId);
        } else {
            console.log("No login data found");
        }
        getCategories();
        getProducts()
    }, []);

    const getCategories = async () => {
        try {
            const resp = await axios.get(
                `${baseUrl}account/${loginData.id}/categories`,
                {
                    headers: {
                        Authorization: `Bearer ${loginData.authToken}`,
                    },
                }
            );
            console.log(resp.data); // Log the response to check
            setCategories(resp?.data);
        } catch (e) {
            console.error(e);
            if (e.response.status === 401) {
                navigate("/admin/login");
            }
        }
    };

    const handleInputChange = (e) => setInputValue(e.target.value);

    const handleInputConfirm = async () => {
        if (inputValue) {
            const newTags = [...categories];

            if (editingTagIndex !== null) {
                // Update the category name via API
                try {
                    const updatedCategory = await axios.put(
                        `${baseUrl}account/${loginData.id}/category/update`,
                        { name: inputValue, id: categories[editingTagIndex].id },
                        {
                            headers: {
                                Authorization: `Bearer ${loginData.authToken}`,
                            },
                        }
                    );
                    newTags[editingTagIndex].name = updatedCategory.data.name; // Update the name in local state
                } catch (e) {
                    message.error("Failed to update category");
                    return;
                }
                finally {
                    getCategories()
                }
            } else {
                // Add a new category via API
                try {
                    const newCategory = await axios.post(
                        `${baseUrl}account/${loginData.id}/category/create`,
                        { name: inputValue },
                        {
                            headers: {
                                Authorization: `Bearer ${loginData.authToken}`,
                            },
                        }
                    );
                    newTags.push(newCategory.data); // Add the new category to the state
                } catch (e) {
                    message.error("Failed to add category");
                    return;
                }
                finally {
                    getCategories()
                }
            }

            //   setCategories(newTags);
            setInputVisible(false);
            setInputValue('');
            setEditingTagIndex(null); // Reset editing index
        }
    };

    const deleteCategory = async (id) => {
        try {
            const resp = await axios.delete(
                `${baseUrl}account/${loginData.id}/categories/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${loginData.authToken}`,
                    },
                }
            );
            if (resp) {
                message.success("Category deleted successfully");
                // Remove the deleted category from the local state
                setCategories(categories.filter(category => category.id !== id));
            }
        } catch (e) {
            console.error(e);
            message.error("Failed to delete category");
            if (e.response.status === 401) {
                navigate("/admin/login");
            }
        }
    };

    const handleTagClose = (id) => {
        deleteCategory(id); // Call deleteCategory on close
        setEditingTagIndex(null); // Reset editing index when tag is removed
    };

    const handleTagClick = (index) => {
        setEditingTagIndex(index); // Set the index of the tag being edited
        setInputValue(categories[index]?.name); // Set the input value to the current tag value
        setInputVisible(true); // Make the input visible for editing
    };

    return (
        <div style={{ display: "flex",flexDirection: "column", alignItems: "flex-start" ,width:"100%",gap:30}}>
          <div style={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom: 24, position: "relative", width: "100%"}}>
  <div style={{textAlign:"center", fontSize:28, fontWeight:600, flex: 1}}>Products</div>
  <Button
    style={{
      padding: 10,
      background: "#f7941d",
      color: "#fff",
      position: "absolute",
      right: 0,
    }}
    onClick={() => { setDrawerVisibility("create"); setProductsReq(initialReq); }}
  >
    ADD PRODUCT
  </Button>
</div>
            <div>
                {categories.map((category, index) => (
                    <Tag
                    color="orange"
                        key={category.id} // Use category.id as the key for better performance
                        closable
                        onClose={() => handleTagClose(category.id)} // Handle tag removal
                        onClick={(e) => {
                            // Only edit the tag when the tag itself is clicked, not the close icon
                            if (e.target !== e.currentTarget) return;
                            handleTagClick(index);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {category.name}
                    </Tag>
                ))}

                {inputVisible && (
                    <Input
                        type="text"
                        size="small"
                        style={{ width: 78 }}
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleInputConfirm}
                        onPressEnter={handleInputConfirm}
                    />
                )}

                {!inputVisible && (
                    <Button
                    style={{background:"#f7941d",color:"#fff"}}
                        size="small"
                        type="dashed"
                        onClick={() => setInputVisible(true)}
                    >
                        + Add Category
                    </Button>
                )}
            </div>

            <div>
      <Table<DataType> dataSource={products}  pagination={{ pageSize: 20 }}>
<Column title="Name" dataIndex="name" key="name" />
<Column
        title="Description"
        dataIndex="description"
        key="description"
        ellipsis
        render={(text) => (
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {text}
          </div>
        )}
      />
    <Column
        title="Category"
        dataIndex="categoryName"
        key="categoryName"
        ellipsis
        render={(text) => (
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {text || "-"}
          </div>
        )}
      />
<Column
title="Images"
dataIndex="images"
key="images"
render={(images: any) => (
    <div>
    {images?.length > 0 &&
      images.map((i, index) => (
        <Popover content={<div>{i ?<img src={i} style={{width:"200",height:"200px"}}></img>:"No Data"}</div>} trigger="click" >
 <img
          key={index}
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "6px",
            cursor: "pointer", // Make the image look clickable
            marginRight: 10,
          }}
          src={i}
          alt={`image-${index}`}
        />
        </Popover>
       
      ))}
  </div>


)}
/>
<Column
title="Action"
key="action"
render={(_: any, record: any) => (
 <Space size="middle">
    <EditOutlined onClick={()=>{setProductsReq(record);setDrawerVisibility("update")}}/>
   <DeleteOutlined color="#FFF" style={{color:"red"}}  onClick={()=>deleteProducts(record?.id)}/>
 </Space>
)}
/>
</Table>
            </div>
            <Drawer
        title={drawerVisibility=="create" ?"Add Product":"Edit Product"}
        placement="right"
        width={400}
        onClose={onClose}
        open={drawerVisibility? true : false}
        closable={true} // Close icon
        bodyStyle={{ paddingBottom: 80 }} // Add some padding at the bottom
      >
        {/* Product Name */}
        <div style={{ marginBottom: 16 }}>
          <label>Product Name*</label>
          <Input
            value={productsReq?.name}
            onChange={(e) => setProductsReq({...productsReq,name:e.target.value})}
            placeholder="Enter product name"
          />
        </div>

        {/* Description */}
        <div style={{ marginBottom: 16 }}>
          <label>Description*</label>
          <TextArea
            value={productsReq.description}
            onChange={(e) => setProductsReq({...productsReq,description:e.target.value})}
            placeholder="Enter description"
            rows={4}
          />
        </div>

        {/* Category */}
        <div style={{ marginBottom: 16 }}>
          <label>Category</label>
          <Select
            value={productsReq.categoryId}
            onChange={(value) => setProductsReq({...productsReq,categoryId:value})}
            placeholder="Select a category"
            style={{ width: '100%' }}
          >
            {categories?.map((c)=>{
                return  <Select.Option value={c?.id}>{c?.name}</Select.Option>
            })}
          </Select>
        </div>

        <div style={{ marginBottom: 10 }}>
          <div >Product Images</div>
          <Upload
            accept="image/*"
            showUploadList={false}
            beforeUpload={() => false} // Disable automatic upload
            onChange={handleFileChange}
            onPreview={handlePreview}
            maxCount={1} // Limit to 1 file
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </div>
        
        {productsReq?.images && (
          <div style={{ marginTop: 10 }}>
          {
            productsReq?.images?.map((i,index)=>{
               return       <Popover content={<div>{i ?<img src={i} style={{width:"200",height:"200px"}}></img>:"No Data"}</div>} trigger="click" >
               <img
                        key={index}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "6px",
                          cursor: "pointer", // Make the image look clickable
                          marginRight: 10,
                        }}
                        src={i}
                        alt={`image-${index}`}
                      />
                      </Popover>
            })
          }
          </div>
        )}

        {/* Footer with Cancel and Update buttons */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 16,
            background: '#f0f2f5',
            textAlign: 'right',
          }}
        >
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={ drawerVisibility=="create" ? addProducts:updateProduct}
            loading={loading} // Show loading spinner when updating
          >
            Update
          </Button>
        </div>
      </Drawer>
        </div>
    );
};
